import { MstSyouninGroupsApi } from "@/api/MstSyouninGroupsApi";
import { SyainApi } from "@/api/SyainApi";
import { DetailInputData, DetailData, ListData, SearchForm } from "@/types/Syain";
import { SyozokuSyouninGroup } from "@/types/SyouninGroup";

export class SyainService {

  /**
   * 社員情報一覧を取得します
   * @returns
   */
  public async getList(params: SearchForm): Promise<ListData[]> {
    const api = new SyainApi();
    const req = {};
    let res = null;
    try {
      res = await api.getList(params);
    } catch (e: any) {
      return [];
    }

    if (!res) {
      return [];
    }
    return res;
  }

  /**
   * あるユーザの社員情報を取得します
   * @returns
   */
  public async getInfo(userId: number): Promise<DetailData> {
    const api = new SyainApi();
    let res = null;
    try {
      res = await api.getInfo(userId);
    } catch (e: any) {
      return {} as DetailData;
    }

    if (!res) {
      return {} as DetailData;
    }
    return res;
  }

  /**
   * あるユーザの社員情報を取得します（更新用）
   * @returns
   */
  public async getInfoForUpdate(userId: number, koyouKeiyakuId: number): Promise<DetailInputData> {
    const api = new SyainApi();
    const req = { userId: userId, koyouKeiyakuId: koyouKeiyakuId };
    let res = null;
    try {
      res = await api.getInfoForUpdate(req);
    } catch (e: any) {
      return {} as DetailInputData;
    }

    if (!res) {
      return {} as DetailInputData;
    }
    return res;
  }

  /**
   * 社員マスタを更新します
   */
  public async update(form: DetailInputData): Promise<number> {
    const api = new SyainApi();
    try {
      const res = await api.update(form);
      return res
    } catch (e: any) {
      throw e
    }
  }

  /**
   * 社員マスタを登録します
   */
  public async create(form: DetailInputData): Promise<number> {
    const api = new SyainApi();
    try {
      const res = await api.create(form);
      return res
    } catch (e: any) {
      throw e
    }
  }

  /**
   * オプションを取得します
   */
  public async getAllOptions(): Promise<any> {
    const api = new SyainApi();
    try {
      let res = await api.getAllOptions()
      return res
    } catch (e) {
      throw e;
    }
  }

  /**
   * 指定したユーザーが所属する承認グループ情報を返します
   */
  public async getSyozokuSyouninGroup(userId: number): Promise<SyozokuSyouninGroup> {
    const api = new SyainApi();
    try {
      return await api.getSyozokuSyouninGroup(userId);
    } catch (e: any) {
      return e;
    }
  }

  /**
   * 社員マスタを更新します
   */
  public async updateKoyouKeiyakuNotes(userId: number, notes: string | null): Promise<DetailData> {
    const api = new SyainApi();
    try {
      const res = await api.updateKoyouKeiyakuNotes(userId, notes);
      return res
    } catch (e: any) {
      throw e
    }
  }
  
  /**
   * 全ユーザーを返します（管理者ロールを除く）
   */
  public async getAllSyain() {
    const api = new SyainApi();
    try {
      return await api.getAllSyain()
    } catch (e) {
      throw e;
    }
  }

  /**
   * 全ユーザーを返します（管理者ロールを除く／オプション値）
   */
  public async getAllSyainOptions() {
    const api = new SyainApi();
    try {
      return await api.getAllSyainOptions()
    } catch (e) {
      throw e;
    }
  }
  
}
